<template>
  <div class="category-list md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
    <CategoryCard
      v-for="category in categoryList"
      :key="category.identifier"
      :category="category"
      :language="language"
    />
  </div>
</template>

<script>
import CategoryCard from "./CategoryCard.vue";
export default {
  components: { CategoryCard },
  name: "CategoryList",
  props: {
    categoryList: {
      type: Array,
      default: [],
    },
    language: {
      type: String,
      default: "en",
    },
  },
};
</script>

<style>
.category-list {
  padding-top: 1rem;
  display: grid;
  grid-gap: 1rem;
}

.category-list .rofix-card {
  padding: 0 1.2rem;
}
</style>
